export const IS_SCROLLING_DEBOUNCE_INTERVAL = 200
